import type { SVGProps } from 'react'
const SvgSyBag = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				d="M12 1.75a4.533 4.533 0 0 0-4.54 4.502v3.053a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75V6.26a3.01 3.01 0 0 1 3.038-3.01H12a3.013 3.013 0 0 1 3.023 3.023v3.032a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75V6.273a4.536 4.536 0 0 0-4.519-4.523z"
				opacity={0.4}
			/>
			<path
				fillRule="evenodd"
				d="M7.258 6.225a5.017 5.017 0 0 0-5.008 5.004v5.517a5.017 5.017 0 0 0 5.008 5.004h9.484a5.017 5.017 0 0 0 5.008-5.004V11.23a5.017 5.017 0 0 0-5.008-5.004zm0 1.5h9.484a3.494 3.494 0 0 1 3.508 3.504v5.517a3.494 3.494 0 0 1-3.508 3.504H7.258a3.494 3.494 0 0 1-3.508-3.504V11.23a3.494 3.494 0 0 1 3.508-3.504"
				clipRule="evenodd"
			/>
		</g>
	</svg>
)
export default SvgSyBag
